<template lang="html">
  <b-container fluid tag="section" class="landing bg-service flex-fill">
    <b-row class="align-items-center h-100 py-5">
      <b-col cols="11" md="5" lg="4" class="mx-auto text-center py-4 error__wrapper">
        <div class="error__codeBox error__text error__code mb-1">
          <component :is="currentCodeImage"></component>
        </div>
        <div class="error__divider mb-4 w-80 mx-auto"></div>
        <div class="mb-3">
          <div class="font-weight-normal error__title error__text mb-2">{{ errorMessage }}</div>
          <div class="error__description">{{ errorSubMessage }}</div>
        </div>
        <div class="error__btn">
          <b-btn pill variant="service" class="shadow" :to="{name: 'landing'}">Go to home</b-btn>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import clipSticker from '@uiComponent/util/sticker/clip.vue'
import Code400 from '@uiComponent/util/error-code/400'
import Code404 from '@uiComponent/util/error-code/404'
import Code500 from '@uiComponent/util/error-code/500'
import fullScreen from '@viewMixin/fullScreen'

export default {
  name: 'error-page',
  metaInfo: {
    meta: [
      { vmid: 'title', content: 'Clippler | Not Found' },
      { vmid: 'og:title', content: 'Clippler | Not Found' }
    ]
  },
  components: {
    clipSticker,
    Code404
  },
  mixins: [fullScreen],
  computed: {
    currentCodeImage () {
      switch (this.$route.path) {
        case '/404':
          return Code404
        case '/500':
          return Code500
        default:
          return Code400
      }
    },
    errorMessage () {
      switch (this.$route.path) {
        case '/404':
          return 'Page Not Found'
        case '/500':
          return 'Internal Server Error'
        default:
          return 'Something went wrong'
      }
    },
    errorSubMessage () {
      switch (this.$route.path) {
        case '/404':
          return 'We didn\'t found what page you want to move.'
        default:
          return 'Please, Try some later.'
      }
    }
  },
  created () {
    window.addEventListener('resize', this.estimateViewHeight, false)
    this.estimateViewHeight()
    this.setFullHeight()
  },
  mounted () {
    this.setHeightFull()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.estimateViewHeight)
    this.unSetFullHeight()
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/error-page.vue